<template>
  <div class="centerx">
    <vs-upload multiple
               data-cy="dropzone"
               text="Wgraj Umowę"
               @change="handleChange"
               :show-upload-button="false"
               @on-delete="handleDelete"
    />
  </div>
</template>

<script>
import 'firebase/storage'
import { uid } from 'uid'

import {upload} from '../../plugins/express';
import {EVENT_CLEAR_FILES, EventBus} from '../../utils/EventBus';

export default {
  name: 'UploadFiles',
  created() {
    EventBus.$once(EVENT_CLEAR_FILES, () => {
      this.files = [];
    })
  },
  data() {
    return {
      files: [],
      counter: 0
    }
  },
  computed: {
    realFiles() {
      return this.files.filter(f => f.hasOwnProperty('id'));
    }
  },
  methods: {
    validateType(type) {
      return ['image/png', 'image/jpeg', 'application/pdf'].includes(type);
    },
    mapNameToPath(name, file_id) {
      const ext = name.split('.').pop();
      return `emulex/${this.$store.state.id}/${file_id}.${ext}`;
    },
    async handleChange(userPath, files) {
      const id = uid();

      files = files.filter(f => !f.hasOwnProperty('remove'))

      const index = files.length - 1;
      const lastFile = files[index]

      const path = this.mapNameToPath(lastFile.name, id);
      const buffer = await lastFile.arrayBuffer();

      if (!this.validateType(lastFile.type)) {
        this.files.push({
          id,
          state: 'removed',
          name: lastFile.name,
          path,
          lastModified: lastFile.lastModified
        });
        this.$emit('change', this.realFiles);

        return this.$vs.notify({
          title: 'Nie poprawny plik',
          text: 'Możliwe są tylko jpg, jpeg, png, pdf.',
          color: 'red'
        })
      }

      this.files.push({
        id,
        state: 'pending',
        name: lastFile.name,
        path,
        lastModified: lastFile.lastModified
      });
      this.$emit('change', this.realFiles);

      await this.$store.dispatch('incFileOrder');
      try {
        const res = await upload(path, buffer);
        this.files.splice(index, 1, {...this.files[index], state: res.data.queued ? 'queued' : 'removed'});
        this.$emit('change', this.files);
      } catch (e) {
        this.files.splice(index, 1, {...this.files[index], state: 'removed'});
        this.$emit('change', this.files);
        return this.$vs.notify({
          title: 'Błąd przy przyjmowaniu pliku',
          text: e.message,
          color: 'red'
        })
      }
    },
    handleDelete(file) {
      const index = this.files.findIndex(f => f.name === file.name && f.lastModified === file.lastModified);
      this.files.splice(index, 1);
      this.$emit('change', this.realFiles);
    }
  }
}
</script>

<style>
.full-width {
  width: 100%;
}
</style>
